import { instances, getInstanceByElement } from './componentUtils';

export default class Component {

    constructor(element) {
        this.element = element;
        this._instance = getInstanceByElement(element);
        this._name = this._instance.componentName;
        this.ref = this.getRefElements();
        if (this.element.dataset.options != null) {
            this.options = JSON.parse(this.element.dataset.options);
        }
    }

    prepare() {
        console.warn(`Komponenta ${this._name} nemá metodu prepare().`);
    }

    require = async function() {
        return null
    }

    load () {
        this.require().then(::this.prepare)
    }

    destroy() {
        //console.warn('Destroy method: override me');
    }

    getElement() {
        return this.element;
    }

    getRef(ref) {
        return `[data-ref="${ref}"]`;
    }

    getRefElement(ref, context = this.element) {
        return context.querySelector(`[data-ref="${ref}"]`);
    }

    getRefElements(context = this.element) {
        let important = {};
        let ref = {};
        // write refs
        context.querySelectorAll('[data-ref]').forEach(item => {
            let name = item.dataset.ref;
            if (name.split(':').length > 1) {
                // take only refs for this component
                if (name.split(':')[0] == this._name){
                    important[name.split(':')[1]] = item;
                }
            } else {
                if (name.includes('[]')) {
                    let n = name.replace('[]', '');
                    if(ref[n] == null) {
                        ref[n] = [];
                        ref[n].push(item);
                    } else {
                        ref[n].push(item);
                    }
                } else {
                    ref[item.dataset.ref] = item;
                }
            }
        });

        // rewrite refs with specific refs
        ref = {
            ...ref,
            ...important
        }

        return ref;
    }

    static getFromElement(element) {
        let instance = getInstanceByElement(element);
        return instance;
    }

}

//window.Component = Component


// WEBPACK FOOTER //
// ./core/Component.js